import { API_BASE_URL } from './config';

const BASE = API_BASE_URL;

const req = async (url, options = {}) => {
  const res = await fetch(url, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  const data = await res.json();
  return data;
};

export const employeeApi = {
  getAll: (page = 1, limit = 10, role = '', department = '') => {
    const params = new URLSearchParams({ page, limit });
    if (role) params.append('role', role);
    if (department) params.append('department', department);
    return req(`${BASE}/employee.php?${params}`);
  },

  getById: (id) => req(`${BASE}/employee.php?id=${id}`),

  create: (data) =>
    req(`${BASE}/employee.php`, { method: 'POST', body: JSON.stringify(data) }),

  update: (id, data) =>
    req(`${BASE}/employee.php?id=${id}`, { method: 'PUT', body: JSON.stringify(data) }),

  delete: (id) => req(`${BASE}/employee.php?id=${id}`, { method: 'DELETE' }),

  getScreenAccess: (employeeId) =>
    req(`${BASE}/screen_access.php?employee_id=${employeeId}`),

  updateScreenAccess: (employeeId, screens) =>
    req(`${BASE}/screen_access.php?employee_id=${employeeId}`, {
      method: 'PUT',
      body: JSON.stringify({ screens }),
    }),
};

export const SCREENS = [
  'Dashboard',
  'Customers',
  'Users',
  'Upload',
  'Add Form',
  'Employees',
  'Tasks',
  'Birthdays',
];

export const DEPARTMENTS = ['Loans', 'Operations', 'HR', 'Finance', 'IT', 'Sales', 'Compliance'];
export const DESIGNATIONS = ['Officer', 'Manager', 'Analyst', 'Executive', 'Director', 'Clerk'];
